module.exports = __webpack_public_path__ + "img/165.20f9cef8.jpg";